<template>
    <div class="sales-filter" v-if="currentCity.length && projectItems != null">

        <div class="sales-parent-title" v-if="title != null">
            <h1 v-if="routerName == 'sales'">{{title}}</h1>
            <h3 v-if="routerName == 'home'">{{title}}</h3>
        </div>
        <div class="sales-filter-city-dropwdown"> <!-- Выпадашка городов -->
            <div class="curent-city" :class="{'open' : openDropInit}">
                <a href="#" :class="{active : cityActive === 'all'}" @click.prevent="openDrop">
                    <span v-if="lang == 'kz/'">Барлық қалалар</span>
                    <span v-else>Все города</span>
                </a>
                <a href="#" :class="{active : cityActive === item}" v-for="(item, index) in cityFilter" :key="index" @click.prevent="openDrop">{{cityFilterNames[index]}}</a>
                <div class="drop-icon">
                    <svg-icon icon-class="arrow_drop" className="icon-svg"/>
                </div>
            </div>
            <div class="city-dropdown" :class="{'open' : openDropInit}">
                <ul>
                    <li>
                        <a href="#" :class="{active : cityActive === 'all'}" @click.prevent="filterByCity('all'), openDropInit = false">
                            <span v-if="lang == 'kz/'">Барлық қалалар</span>
                            <span v-else>Все города</span>
                        </a>
                    </li>
                    <li v-for="(item, index) in cityFilter" :key="index">
                        <a href="#" @click.prevent="filterByCity(item), openDropInit = false" :class="{active : cityActive === item}">{{cityFilterNames[index]}}</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="sales-filter-city sales-filter-default" v-if="routerName != 'favorite-projects'">
            <ul>
                <li v-for="(item, index) in cityFilter" :key="index">
                    <a href="#" @click.prevent="filterByCity(item)" :class="{active : cityActive === item}">{{cityFilterNames[index]}}</a>
                </li>
            </ul>
        </div>
        
        <div class="links-group">
            <div class="link-to-map-page" v-if="routerName != 'sales-map' && routerName != 'favorite-projects'">
                <router-link to="/sales-map" @click.native="startLoader">
                    <span v-if="lang == 'kz/'">Картадағы кешендер</span>
                    <span v-else>Комплексы на карте</span>
                </router-link>
            </div>
            <div class="link-to-sales-page" v-if="routerName == 'home' && routerName != 'favorite-projects'">
                <router-link to="/sales" @click.native="startLoader">
                    <span v-if="lang == 'kz/'">Барлық тұрғын үй кешендері</span>
                    <span v-else>Все жилые комплексы</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sales-filter',
        props: ['title'],
        components: {
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                cityFilterNames: [],
                cityFilter: [],
                themeFilter: [],
                cityActive: null,
                themeActive: null,
                initFilter: false,
                filterArr: [],
                saleStat: 0,
                openDropInit: false,
                lang: window.GlobalLang,
            }
        },
        methods: {
            buildFiterCity() {
                if (this.projectItemsFilter != null) {
                    this.cityFilter = [];
                    
                    var data = this.projectItemsFilter;
                    var i;
                    var n;
                    // console.log(data, 'test')
                    for (i = 0; i < data.length; i++) {
                        // console.log(data[i].project_name.slug)
                        if (data[i].project_name.slug != 'yassytower') {
                            this.cityFilter.push(data[i].city_name.slug);
                            this.cityFilterNames.push(data[i].city_name.name);
                        }
                    }
                    
                    this.cityFilter = this.uniqueElementsInArray(this.cityFilter);
                    this.cityFilterNames = this.uniqueElementsInArray(this.cityFilterNames);
                }
                // console.log(this.cityFilter, this.cityFilterNames, 'cityyyy')

                // console.log(this.cityFilter, this.themeFilter);
            },
            uniqueElementsInArray(arr) {
                let result = [];
                for (let str of arr) {
                    if (!result.includes(str)) {
                        result.push(str);
                    }
                }
                return result;
            },
            filterByCity(city) {
                this.cityActive = city;
                this.initFilter = true;

                var local_url = window.location
                var cityUrl = new URL(window.location.href).searchParams.get('city');
                // var actionCode = new URL(window.location.href).searchParams.get('oobCode');
                // console.log(local_url, cityUrl);

                
                if (city != 'all' ) {
                    if (this.routerName == 'sales') {
                        var data = this.projectItemsDefault;
                        // Стандартный фильтр по городам
                        if (cityUrl == null && this.saleStat != 1) {
                            this.saleStat = 1;
                            this.cityActive = 'all';
                            this.initFilter = false;
                            this.$store.commit('filterProjectsItems', data);
                            this.$store.commit('setProjectFilCity', null);
                        } else if (cityUrl != null && this.saleStat != 1) {
                            this.saleStat = 1;
                            this.cityActive = cityUrl;
                            this.initFilter = true;
                            var filteredItems = data.filter(item => {
                                return item.city_name.slug == cityUrl
                            })
                            this.$store.commit('filterProjectsItems', filteredItems);
                            this.$store.commit('setProjectFilCity', cityUrl);
                        } else {
                            var filteredItems = data.filter(item => {
                                return item.city_name.slug == city
                            })
                            this.$store.commit('setProjectFilCity', city);
                            this.$store.commit('filterProjectsItems', filteredItems);
                        }

                        // if (this.saleStat != 1 && cityUrl == null) {
                        //     this.saleStat = 1;
                        //     this.cityActive = null;
                        //     this.initFilter = false;
                        //     this.$store.commit('filterProjectsItems', data);
                        // } else if (cityUrl != null) {
                        //     var filteredItems = data.filter(item => {
                        //         return item.city_name.slug == cityUrl
                        //     })
                        //     this.$store.commit('filterProjectsItems', filteredItems);
                        // } else {
                        //     var filteredItems = data.filter(item => {
                        //         return item.city_name.slug == city
                        //     })
                        //     this.$store.commit('filterProjectsItems', filteredItems);
                        // }
                    } else {
                        var data = this.projectItemsDefault;
                        var filteredItems = data.filter(item => {
                            return item.city_name.slug == city
                        })
                        this.$store.commit('filterProjectsItems', filteredItems);
                        this.$store.commit('setProjectFilCity', city);
                    }
                } else {
                    this.cityActive = city;
                    var data = this.projectItemsDefault;
                    this.$store.commit('filterProjectsItems', data);
                    this.$store.commit('setProjectFilCity', city);
                }

                
                // if (filteredItems.length == 0) { // Фильтрации при условии что в выбранном городе нет объектов в продаже
                //     this.cityActive = 'almaty';
                //     var filteredItemsEmpty = data.filter(item => {
                //         return item.city_name.slug == 'almaty'
                //     });
                //     this.$store.commit('filterProjectsItems', filteredItemsEmpty);
                // }
                
                //  Фильтр для карты жилых комплексов
                if (this.routerName == 'sales-map' && this.setup != null) {
                    var data = this.setup.regions_name;
                    var filteredCity = data.filter(item => {
                        return item.region_lat.slug == city
                    });
                    // console.log(data, filteredCity);
                    this.$store.commit('filterMapCoords', filteredCity);
                    this.$store.commit('filterProjectsItemsMap', filteredItems);
                    // console.log(filteredCity, filteredItems);

                    if (filteredItems.length == 0) { // Фильтрации при условии что в выбранном городе нет объектов в продаже
                        var filteredCityEmpty = data.filter(item => {
                            return item.region_lat.slug == 'almaty'
                        });
                        this.$store.commit('filterMapCoords', filteredCityEmpty);
                        this.$store.commit('filterProjectsItemsMap', filteredItemsEmpty);
                        // console.log(filteredCityEmpty, 'CITY')
                    }
                }

                // Фильтр для избранных
                if (this.routerName == 'favorite-projects') {
                    var data = this.projectItemsDefault;
                    var favorite = localStorage.getItem('favorite_projects');
                    favorite = favorite ? favorite.split(',') : [];
                    var i;
                    var n;
                    var favoriteItems = [];
                    for (i=0; i < favorite.length; i++) {
                        for (n=0; n < data.length; n++) {
                            if (data[n].project_name.name == favorite[i]) {
                                favoriteItems.push(data[n])
                            }
                        }
                    }
                    this.$store.commit('filterProjectsItems', favoriteItems);
                }

                // Фильтр на главной если в городе нет жк для продаж
                if (this.routerName == 'home') {
                    var items = [];
                    var i;
                    // console.log('HOME FROM FILTER', data, filteredItems)
                    if (city != 'all') {
                        if (filteredItems.length == 0) {
                            this.cityActive = null;
                            var almatyItem = data.filter(item => {
                                return item.city_name.slug == 'almaty'
                            });
                            var astanaItem = data.filter(item => {
                                return item.city_name.slug == 'nur-sultan'
                            });

                            for (i=0; i < 4; i++) {
                                items.push(almatyItem[i]);
                                items.push(astanaItem[i]);
                            }

                            // console.log(almatyItem, items);
                            this.$store.commit('filterProjectsItems', items);
                        }
                    }
                }
                this.animateCards();
            },
            animateCards() {
                this.$store.commit('cardAnimateSet', false);
                setTimeout(()=>{
                    this.$store.commit('cardAnimateSet', true);
                },50);
            },
            initFilterCityByPageLoad() {
                // console.log(this.currentCity, 'sales_filter')
                if (this.currentCity.length && this.projectItemsFilter != null) {
                    this.filterByCity(this.currentCity);
                }
            },
            startLoader() {
                if (this.routerName == 'home') {
                    this.$parent.$parent.$parent.$refs.topProgress.start();
                } else {
                    this.$parent.$parent.$refs.topProgress.start();
                }
            },
            openDrop() {
                this.openDropInit = !this.openDropInit;
            }
        },
        computed: mapGetters({
            currentCity: 'loadCurrentCity',
            setup: 'loadPageSetUp',
            projectItems: 'loadProjectItems',
            projectItemsDefault: 'loadProjectItemsDefault',
            projectItemsFilter: 'loadProjectItemsFilter',
        }),
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.buildFiterCity();
            this.initFilterCityByPageLoad();
            this.$store.watch(
                (state) => state.projectItemsFilter,
                (newValue) => {
                    this.buildFiterCity();
                    this.initFilterCityByPageLoad();
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/realestate/sales-filter.scss';
    @import '@/styles/respond/sales/respond-sales-filter.scss';
</style>